/* hx-flavour-select.js — one flavour dropdown, wherever it renders.

   The markup comes from snippets/hx-flavour-select.liquid, or from upgrade()
   below when an app hands the page a native <select> instead. Every listener
   is delegated from the document, so a dropdown that arrives after load — the
   quick view sheet, the Simple Bundles selector — behaves without being wired
   up again. That is the whole point of this file: the behaviour used to live
   in hx-pdp.js, which only loads on a product page, so the same dropdown was
   dead on a collection page and on a landing page.

   Picking writes the chosen value into the dropdown's hidden input and fires a
   bubbling hx:flavour-change. data-writes says what that value is: "id" when
   the input is the form's name="id" and Shopify wants a variant id, "title"
   when it is a line item property and Shopify wants the flavour's name.

   The chips (snippets/hx-flavour-pills.liquid, the buy box's flavour choice
   as a row of buttons) are handled here too, at pickPill: a tap fires the
   same event with the same detail, so whatever follows a dropdown follows a
   chip. */
(function(){
  if (window.HxFlavourSelect) return;

  var SEL = '[data-flavour-select]';
  var ARROW = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3v10M4 9l4 4 4-4"/></svg>';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function closeAll(except){
    var open = document.querySelectorAll(SEL + '.open');
    for (var i = 0; i < open.length; i++) if (open[i] !== except) open[i].classList.remove('open');
  }

  /* The scroll cue. A menu shows --menu-rows rows (hx-tokens.css) and the rest
     scroll. The first time a menu opens, its options move into .mlist, the
     part that scrolls, and the menu gains .mrail, a scroll line drawn here so
     it shows on a phone too, and .mrow, a row under the last option in view
     that says how many are below and moves the list a row when tapped. Both
     repaint as the list scrolls; the row goes at the end, and a list that
     fits never shows either. Any .select gets this, not only ours: the quiz
     offer box builds its own and opens it with its own click handler. */
  function rowHeight(list){
    var b = list.querySelector('button');
    return (b && b.offsetHeight) || 48;   // 48 is --menu-row, the token's own fallback
  }

  function words(sel, n){
    var one = sel.dataset.moreOne || '1 more flavour';
    var other = sel.dataset.moreOther || '[n] more flavours';
    return n === 1 ? one : other.replace('[n]', String(n));
  }

  function paint(sel){
    var menu = sel.querySelector('.menu');
    var list = menu && menu.querySelector('.mlist');
    if (!list) return;
    var max = list.scrollHeight - list.clientHeight;
    var scrolls = max > 2;
    menu.classList.toggle('scrolls', scrolls);
    menu.classList.toggle('at-end', !scrolls || list.scrollTop >= max - 1);
    var rail = menu.querySelector('.mrail'), thumb = rail && rail.firstElementChild;
    if (rail && thumb && scrolls){
      var span = list.clientHeight - 8;
      var h = Math.max(24, Math.round(list.clientHeight / list.scrollHeight * span));
      rail.style.height = span + 'px';
      thumb.style.height = h + 'px';
      thumb.style.top = Math.round(list.scrollTop / max * (span - h)) + 'px';
    }
    var row = menu.querySelector('.mrow');
    if (row && scrolls) row.firstElementChild.textContent = words(sel, Math.max(0, Math.ceil((max - list.scrollTop) / rowHeight(list))));
  }

  function enhance(sel){
    var menu = sel.querySelector('.menu');
    if (!menu) return;
    var list = menu.querySelector('.mlist');
    if (!list){
      list = document.createElement('div');
      list.className = 'mlist';
      while (menu.firstChild) list.appendChild(menu.firstChild);
      menu.appendChild(list);
      var rail = document.createElement('div');
      rail.className = 'mrail';
      rail.setAttribute('aria-hidden', 'true');
      rail.innerHTML = '<i></i>';
      menu.appendChild(rail);
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'mrow';
      row.innerHTML = '<span></span>' + ARROW;
      menu.appendChild(row);
      list.addEventListener('scroll', function(){ paint(sel); }, {passive: true});
    }
    // rows are not one height everywhere (the mini select, the phone, the buy box
    // grid all set their own), so the window is measured off the first row:
    // --menu-rows of them, whatever they are, and the token's height is the fallback
    menu.style.setProperty('--menu-row', rowHeight(list) + 'px');
    // the chosen option is in view when the menu opens, even when it sits below the fold
    var on = list.querySelector('button.on');
    if (on && on.offsetTop + on.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = on.offsetTop + on.offsetHeight - list.clientHeight;
    paint(sel);
    // and the whole menu, cue included, is on screen: a dropdown low in the quick
    // view sheet or near the foot of a phone screen opens below the fold otherwise
    if (menu.scrollIntoView) menu.scrollIntoView({block: 'nearest', behavior: reduce ? 'auto' : 'smooth'});
  }

  function nudge(sel){
    var list = sel.querySelector('.menu .mlist');
    if (list) list.scrollBy({top: rowHeight(list), behavior: reduce ? 'auto' : 'smooth'});
  }

  function pick(sel, btn){
    if (!sel || !btn || btn.disabled) return;
    var opts = sel.querySelectorAll('.menu button');
    for (var i = 0; i < opts.length; i++) opts[i].classList.toggle('on', opts[i] === btn);

    var cur = sel.querySelector('.cur');
    if (cur){
      var label = cur.querySelector('span');
      if (label) label.textContent = btn.dataset.t || btn.textContent.trim();
      var curImg = cur.querySelector('img'), btnImg = btn.querySelector('img');
      if (curImg && btnImg) curImg.src = btnImg.src;
      // the chosen flavour's tag (Best seller, Selling fast, Limited) from the row's data-tag
      var curTag = cur.querySelector('.cur-tag');
      if (curTag){ var tg = btn.dataset.tag || ''; curTag.textContent = tg; curTag.hidden = !tg; curTag.classList.toggle('soft', tg === 'Selling fast'); }
    }
    sel.classList.remove('open');

    var hidden = sel.querySelector('input[type=hidden]');
    if (hidden) hidden.value = sel.dataset.writes === 'id' ? btn.dataset.id : (btn.dataset.t || '');

    sel.dispatchEvent(new CustomEvent('hx:flavour-change', {bubbles: true, detail: {
      id: +btn.dataset.id || 0,
      title: btn.dataset.t || '',
      short: btn.dataset.short || '',
      img: btn.dataset.img || '',
      value: btn.dataset.v != null ? btn.dataset.v : (btn.dataset.t || ''),
      button: btn
    }}));
  }

  /* The chips. One button per variant, the chosen one .on; a tap marks it and
     fires the hx:flavour-change the dropdown fires, with the same detail. A
     chip writes nothing to the form, as the buy box's own dropdown does not:
     hx-pdp.js sets the variant input when it follows the event. Built on
     14 Oct 2026 for the split test of the chips against the dropdown on Burn
     (product.hx-pdp-tiers-pills against product.hx-pdp-tiers). */
  var PILLS = '[data-flavour-pills]';
  function pickPill(group, btn){
    if (!group || !btn || btn.disabled) return;
    var all = group.querySelectorAll('button');
    for (var i = 0; i < all.length; i++){
      var on = all[i] === btn;
      all[i].classList.toggle('on', on);
      all[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
    group.dispatchEvent(new CustomEvent('hx:flavour-change', {bubbles: true, detail: {
      id: +btn.dataset.id || 0,
      title: btn.dataset.t || '',
      short: btn.dataset.short || '',
      img: btn.dataset.img || '',
      value: btn.dataset.t || '',
      button: btn
    }}));
  }

  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var pill = e.target.closest(PILLS + ' button');
    if (pill){ e.preventDefault(); pickPill(pill.closest(PILLS), pill); closeAll(); return; }
    var cur = e.target.closest(SEL + ' .cur');
    if (cur){
      var sel = cur.closest(SEL);
      e.preventDefault(); e.stopPropagation();
      closeAll(sel);
      sel.classList.toggle('open');
      if (sel.classList.contains('open')) enhance(sel);
      return;
    }
    var more = e.target.closest('.select .menu .mrow');
    if (more){ e.preventDefault(); e.stopPropagation(); nudge(more.closest('.select')); return; }
    var btn = e.target.closest(SEL + ' .menu button');
    if (btn){ e.preventDefault(); pick(btn.closest(SEL), btn); return; }
    // a dropdown that is not ours (the quiz offer's) opened itself a moment ago in its own handler
    var otherCur = e.target.closest('.select .cur');
    if (otherCur){
      var other = otherCur.closest('.select');
      if (other && other.classList.contains('open')) enhance(other);
    }
    closeAll();
  });

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(); });

  /* Build the site's dropdown in front of a native <select> an app injected,
     and keep the two in step. The native select stays in the form and stays
     the only thing submitted, and every pick fires a real change event on it,
     so the app's own listeners still run exactly as they did. Nothing here
     invents availability: an option the app did not disable stays pickable.

     opts.placeholder is what the closed dropdown reads when the select holds
     no value — every choice sold out, or a choice still to make. Showing the
     first option instead would claim a choice nobody made.

     opts.stripPrefix is dropped off the front of every option's label. An app
     that names its choices after the whole product gives you five rows reading
     "Hercules Signature Shaker Bottle Box - Pink"; the caller works out what
     they all share and this shows what is left. The value submitted is
     untouched — only the label changes. */
  function upgrade(native, opts){
    opts = opts || {};
    if (native.dataset.hxUpgraded) return native.hxSelect || null;

    var choices = [];
    for (var i = 0; i < native.options.length; i++){
      var o = native.options[i];
      if (o.value === '') continue;          // the app's "Please select an option"
      choices.push(o);
    }
    if (!choices.length) return null;

    var sel = document.createElement('div');
    sel.className = 'select' + (opts.mini === false ? '' : ' mini');
    sel.setAttribute('data-flavour-select', '');
    sel.dataset.writes = 'none';             // the native select is the input
    var word = String(opts.word || 'flavour');   // what the counting row counts: "2 more flavours", "1 more colour"
    sel.dataset.moreOne = '1 more ' + word;
    sel.dataset.moreOther = '[n] more ' + word + 's';

    var cur = document.createElement('button');
    cur.type = 'button';
    cur.className = 'cur';
    cur.innerHTML = '<span></span><svg width="18" height="18" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

    var menu = document.createElement('div');
    menu.className = 'menu';
    menu.setAttribute('role', 'listbox');

    var strip = String(opts.stripPrefix || '');
    function label(option){
      var t = option.textContent.trim();
      if (strip && t.length > strip.length && t.slice(0, strip.length) === strip) t = t.slice(strip.length).trim() || t;
      return t;
    }

    choices.forEach(function(o){
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'option');
      b.dataset.v = o.value;
      b.dataset.t = label(o);
      b.dataset.short = b.dataset.t.split(' ').pop();
      if (o.disabled) b.disabled = true;
      if (o.selected) b.className = 'on';
      b.textContent = b.dataset.t;
      menu.appendChild(b);
    });

    sel.appendChild(cur);
    sel.appendChild(menu);

    var chosen = native.selectedOptions[0];
    if (chosen && chosen.value === '') chosen = null;
    sel.classList.toggle('unchosen', !chosen);
    cur.querySelector('span').textContent = chosen ? label(chosen)
      : String(opts.placeholder || (native.querySelector('option[value=""]') || {}).textContent || 'Choose an option').trim();

    sel.addEventListener('hx:flavour-change', function(e){
      sel.classList.remove('unchosen');
      if (native.value === e.detail.value) return;
      native.value = e.detail.value;
      native.dispatchEvent(new Event('change', {bubbles: true}));
    });

    native.parentNode.insertBefore(sel, native.nextSibling);
    native.dataset.hxUpgraded = '1';
    native.hxSelect = sel;
    return sel;
  }

  window.HxFlavourSelect = {upgrade: upgrade, pick: pick, pickPill: pickPill, closeAll: closeAll, enhance: enhance};
})();
